import {FormattedMessage} from 'react-intl'
import {
  API_R_200,
  getExternalAppUrl,
  getContextPath,
  REMEMBER_ME_TOKEN,
  SESSION_TIMEOUT, DIVAY_URL
} from '../../../configs/app-configs'
import {history} from '../../../history'
import {AuthService} from '../../../services/authService'
import React from 'react'
import jwt_decode from "jwt-decode";
import {toastError, toastSuccess, trimObjectValues} from '../../../utility'
import AppId from '../../../configs/appId'

export const LOGIN_ACTION = 'LOGIN_ACTION'
export const LOGIN_FAIL_ACTION = 'LOGIN_FAIL_ACTION'
export const LOGOUT_ACTION = 'LOGOUT_ACTION'
export const SAVE_REGISTER_TOKEN = 'SAVE_REGISTER_TOKEN'
export const SAVE_RESET_PASSWORD_TOKEN = 'SAVE_RESET_PASSWORD_TOKEN'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
export const CHANGE_SESSION_EXPIRE_TIME = 'CHANGE_SESSION_EXPIRE_TIME'


export const checkLoginStatus = (authToken, redirectUrl) => {
  return async (dispatch, getState) => {
    try {
      let response = await AuthService.checkLoginByToken()
      const {username} = getState().auth.user
      if (response.status === API_R_200 && username) {
        response = await AuthService.getUserInfo(
          getState().auth.user.username,
          authToken
        )
        dispatch({
          type: LOGIN_ACTION,
          payload: {authToken, user: response.data || {}}
        })
        changeActionExpireTime()
        const {appId} = getState().customizer
        history.push(
          redirectUrl ||
          window.location.pathname.replace(`/${getContextPath(appId)}/`, '/')
        )
      } else {
        console.log(error)
        dispatch({type: LOGOUT_ACTION})
      }
    } catch (error) {
      console.log(error)
      dispatch({type: LOGOUT_ACTION})
    }
  }
}

export const loginAction = (userId, hmac, insId) => {
  return async (dispatch, getState) => {
    const divayUserInfo = {userId, hmac, insId}
    let response = await AuthService.login(divayUserInfo)
    if (response.status === API_R_200) {
      const authToken = response.data.id_token
      const user = jwt_decode(authToken)
      changeActionExpireTime()
      response = await AuthService.getUserInfo(user.username, authToken)
      const {userSettings} = response.data
      if (userSettings) {
        localStorage.setItem('language', userSettings.language.toLowerCase())
      }
      dispatch({
        type: LOGIN_ACTION,
        payload: {authToken, user: response.data || [], divayUserInfo}
      })
      setTimeout(() => {
        if (getState().customizer.appId !== AppId.DIVAY_INSURANCE_APP) {
          window.location.href = getExternalAppUrl(AppId.DIVAY_INSURANCE_APP, '/buy-insurance')
        } else {
          history.push('/buy-insurance')
        }
      },500)
    } else {
      dispatch({
        type: LOGIN_FAIL_ACTION,
        payload: <FormattedMessage id='login.loginFail' />
      })
    }
  }
}


export const createPassword = (password) => {
  return async (dispatch, getState) => {
    try {
      const response = await AuthService.createPassword(
        password,
        getState().auth.register.token
      )
      if (response.status === 200 && response.data) {
        history.push('/complete-information')
      }
    } catch (error) {
    }
  }
}

export const register = (values) => {
  return async () => {
    try {
      const res = await AuthService.register(trimObjectValues(values))
      if (res.status === 200 && res.data) {
        toastSuccess(<FormattedMessage id='register.registerSuccess'/>)
        history.push('/login')
      }
    } catch (error) {
    }
  }
}

export const compeleteInfo = (user) => {
  return async (dispatch, getState) => {
    try {
      user.registerToken = getState().auth.register.token
      const response = await AuthService.compeleteInfo(user)
      if (response.status === 200 && response.data) {
        toastSuccess(<FormattedMessage id='completeInformation.success'/>)
        history.push('/')
      }
    } catch (error) {
      console.log(error)
    }
  }
}

export const saveRegisterToken = (registerToken) => {
  return async (dispatch) => {
    const response = await AuthService.getUserByRegisterToken(registerToken)
    if (response.status === 200 && response.data) {
      dispatch({
        type: SAVE_REGISTER_TOKEN,
        payload: {token: registerToken, user: response.data}
      })
    } else {
      history.push('/')
    }
  }
}

export const saveResetPasswordToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_RESET_PASSWORD_TOKEN,
      payload: token
    })
  }
}

export const forgotPassword = ({username, email}) => {
  return async (dispatch, getState) => {
    try {
      const response = await AuthService.forgotPassword(username, email)
      if (response.status === 200 && response.data) {
        toastSuccess(<FormattedMessage id='forgotPassword.successfull'/>)
        dispatch({
          type: SAVE_RESET_PASSWORD_TOKEN,
          payload: ''
        })
        history.push('/')
      }
    } catch (error) {
    }
  }
}

export const resetPassword = (password) => {
  return async (dispatch, getState) => {
    try {
      const response = await AuthService.resetPassword(
        password,
        getState().auth.resetPasswordToken
      )
      if (response.status === 200 && response.data) {
        toastSuccess(<FormattedMessage id='createPassword.resetSuccessFul'/>)
        dispatch({
          type: SAVE_RESET_PASSWORD_TOKEN,
          payload: ''
        })
        history.push('/')
      }
    } catch (error) {
    }
  }
}

export const logoutAction = () => {
  return async (dispatch, getState) => {
    const {id} = getState().auth.user
    await AuthService.logout(id)
    dispatch({ type: LOGOUT_ACTION })
    window.location.href = DIVAY_URL;
  }
}

export const updateUserInfo = (user, avatarImage) => {
  return async (dispatch) => {
    if (avatarImage) {
      const url = await AuthService.updateAvatar(user, avatarImage)
      user.userSettings.avatar = url || user.userSettings.avatar
    }
    const res = await AuthService.updateUserInfo(user)
    if (res.status === 200) {
      dispatch({type: UPDATE_USER_INFO, payload: res.data})
      toastSuccess(<FormattedMessage id='setting.updateInfo.success'/>)
      history.push('/')
    }
  }
}

export const changePassword = ({oldPassword, newPassword}) => {
  return async (dispatch) => {
    const res = await AuthService.changePassword({oldPassword, newPassword})
    if (res.status === 200) {
      toastSuccess(<FormattedMessage id='changePassword.success'/>)
      history.push('/')
    }
  }
}

export const changeLanguageSetting = (lang, callBack) => {
  return async (dispatch, getState) => {
    const {userSettings = {}} = getState().auth.user
    const value = {...userSettings, language: lang.toUpperCase()}
    const res = await AuthService.changeUserSetting(value)
    if (res.status === 200) {
      callBack()
      toastSuccess(<FormattedMessage id='generalInfo.changeLanguage.success'/>)
      history.push('/')
    }
  }
}

export const changeActionExpireTime = () => {
    return (dispatch) => {
      dispatch({type : CHANGE_SESSION_EXPIRE_TIME})
    }
}
